module.exports = __webpack_public_path__ + "img/Vietnam.c38d1562.png";